module.exports = __webpack_public_path__ + "static/media/avatar.abddc8b2.png";